class Benefits extends HTMLElement {
  constructor() {
    super();
    this.templateElement = this.querySelector("[benefit-content]");
    this._template = this.templateElement?.content?.cloneNode(true);
    this._animationContainer = this.querySelector("[animation-container]");
    this._numberOfBlocks = parseInt(this.getAttribute("number-of-blocks"));
    this.mediaQuery = window.matchMedia("(max-width: 767px)");
    this.mediaQuery.addEventListener("change", (e) => {

      this.handleViewportChange(e.matches); // `true` if mobile

    });

    this.onlyMobileSlider;
    this.mainSliderElement = this.querySelector("[main-slider]");
    this.slideProgressBar = this.querySelector("[slide-progress]");
    this.responsive_breakpoints = JSON.parse(
      this.getAttribute("slide-responsive-breakpoints")
    );
    this.slidePaginationType =
      this.getAttribute("slide-pagination-type") || null;
    this.sliderPerView = this.getAttribute("slide-per-view");

  }

  connectedCallback() {
    this.handleViewportChange(Benefits.isMobile);

  }
  handleViewportChange(isMobile) {
    // You can perform logic only when breakpoint switches
    if (isMobile) {
      setTimeout(() => {
        this.reInitSlider();
        this.detailToggleUpdateSlider();
      }, 100)
    }
    this.checkContainerInView();
  }

  reInitSlider() {
    if (this.onlyMobileSlider?.initialized) {
      this.onlyMobileSlider.update()
    } else {
      this.enableSwiper()
    }
  }
  static get isMobile() {
    return window.innerWidth <= 767;
  }


  detailToggleUpdateSlider() {
    const detailsElements = this.mainSliderElement?.querySelectorAll("details");

    if (!detailsElements || !this.onlyMobileSlider) return;

    detailsElements.forEach((detail) => {
      detail.addEventListener("toggle", () => {
        if (this.onlyMobileSlider?.params?.autoHeight) {
          // Wait for DOM to reflow after <details> toggle
          setTimeout(() => {
            this.onlyMobileSlider.updateAutoHeight();
          }, 100); // 300ms gives time for content to expand/collapse
        }
      });
    });
  }
  checkContainerInView() {
    if (window.animation) {
      this._animationContainer &&
        Motion.inView(
          this._animationContainer,
          this.animateBenefits.bind(this),
          { amount: Benefits.isMobile ? 0.01 : 0.2, once: true }
        );
    }
  }
  animateBenefits() {
    this.isAnimated = true;
    const oddCards = this.querySelectorAll(
      "[benefits-desktop-content] [benefit-card]:nth-child(odd) [animate-card]"
    );
    const evenCards = this.querySelectorAll(
      "[benefits-desktop-content] [benefit-card]:nth-child(even) [animate-card]"
    );
    const sliderCards = this.querySelectorAll(
      "[benefits-slider-content] [animate-card]"
    );
    const desktopCards = this.querySelectorAll(
      "[benefits-desktop-content] [animate-card]"
    );

    const allCards = sliderCards.length > 0 ? sliderCards : desktopCards;

    this._innerCircle = this.parentElement.querySelector(
      "[animation-inner-circle]"
    );

    if (Benefits.isMobile) {
      this.cardAnimation(allCards, null, "mobile");
    } else {
      this.cardAnimation(oddCards, "odd", "desktop");
      this.cardAnimation(evenCards, "even", "desktop");
    }
  }

  enableSwiper() {
    this.onlyMobileSlider = new Swiper(this.mainSliderElement, {
      spaceBetween: 20,
      autoHeight: true,
      slidesPerView: this.sliderPerView,
      pagination: {
        el: this.slideProgressBar,
        type: this.slidePaginationType,
        clickable: true,
      }
    });
  }


  cardAnimation(elements, oddOrEven, mode = "desktop") {
    const isMobile = mode === "mobile";
    const easing = "linear";

    elements.forEach((element, index) => {
      let xOffset = isMobile
        ? "100px"
        : oddOrEven === "even"
          ? "-100px"
          : "100px";

      let cardDelay = 0.1;

      // Apply special offset only for 2nd item (index 1) on desktop
      if (!isMobile && index === 1 && this._numberOfBlocks > 4) {
        xOffset = oddOrEven === "even" ? "-200px" : "200px";
        cardDelay = 0;
      }

      const contentItems = element.querySelectorAll("[animation-card-content]");
      const innerCircle =
        element.querySelector(".inner-circle") || this._innerCircle;
      const combinedSequence = Benefits.isMobile
        ? [
          [
            innerCircle,
            {
              opacity: [0, 1],
              scale: [0.3, 1],
              borderColor: [
                "var(--color-background)",
                "var(--circle-border)",
              ],
            },
            { duration: 0.5, ease: easing },
          ],

          [
            element,
            { opacity: [0, 1], y: [xOffset, 0] },
            { duration: 0.5, ease: "ease-in", delay: Motion.stagger(0.2) },
          ], [
            '[animate-fade]',
            {
              opacity: [0, 1],

            }, { duration: 0.5, ease: "ease-in", delay: Motion.stagger(0.2) }
          ]
        ]
        : [
          [
            element,
            { opacity: 0, x: xOffset },
            { duration: 0, ease: easing },
          ],
          [
            element,
            { opacity: [0, 1], scale: [0, 1] },
            {
              duration: 0.5,
              ease: easing,
              at: "0",
              delay: Motion.stagger(0.2),
            },
          ],
          [
            contentItems,
            { opacity: [0, 1], y: ["30%", "0"] },
            {
              duration: 0.3,
              ease: easing,
              delay: Motion.stagger(0.2),
              at: "0",
            },
          ],
          [
            element,
            { x: 0 },
            { duration: 0.5, ease: "ease-in", at: "-0.5", delay: cardDelay },
          ],
          [
            innerCircle,
            { opacity: [0, 1], scale: [0.3, 1] },
            { duration: 0.3, ease: easing, at: "-0.3" },
          ],
          [
            this._animationContainer,
            {
              borderColor: [
                "var(--color-background)",
                "var(--circle-border)",
              ],
            },
            {
              duration: 0.4,
              ease: easing,
              at: "0.4",
            },
          ],
        ];

      Motion.animate(combinedSequence);
    });
  }
}

customElements.get("benefits-component") ||
  customElements.define("benefits-component", Benefits);
